<template>
  <div id="GuestRecordTabs_main">
    <div class="main">
      <TitleBar
        title="訪客管理列表"
        :introduction="{
          link: 'https://www.smartdaily.com.tw/visitor/',
          product_id: 'visitor_management',
          product_name: '訪客管理',
          subpage_name: tabName
        }"
        tip="可檢視所有訪客出入記錄"
      >
        <template #btns>
          <el-button
            round
            @click="openOldVersionGuestRecord"
          >
            舊訪客紀錄列表
          </el-button>
          <el-button
            round
            @click="openSiteGuestQRCodeDialog"
          >
            現場訪客登記表單QR Code
          </el-button>
          <el-button
            icon="icon-setting"
            round
            @click="openSetUpDialog"
          >
            設定
          </el-button>
        </template>
      </TitleBar>
      <div class="checkin_block">
        <GuestCheckIn
          ref="GuestCheckIn"
          :qrcode-enable="qrcodeEnable"
          :guest-cause-list="guestCauseList"
        />
      </div>
      <el-tabs
        v-model="activeName"
        :before-leave="checkTab"
        class="tabs"
      >
        <el-tab-pane
          label="已預約訪客列表"
          name="PlusGuestReservation"
          class="tab"
        />
        <el-tab-pane
          label="已抵達訪客列表"
          name="GuestRecord"
          class="tab"
        />
      </el-tabs>
      <!-- 訪客設定 -->
      <SetUpDialog
        ref="SetUpDialog"
        @getList="getGuestCauseList"
      />
      <!-- 現場訪客登記表單QR Code -->
      <SiteGuestQRCodeDialog ref="SiteGuestQRCodeDialog" />
      <router-view
        :qrcode-enable="qrcodeEnable"
        :guest-cause-list="guestCauseList"
      />
    </div>
  </div>
</template>
<script>
import TitleBar from '@/components/PageTitleBar.vue'
import SetUpDialog from '../Guest/components/SetUpDialog'
import SiteGuestQRCodeDialog from '../Guest/components/SiteGuestQRCodeDialog'
import GuestCheckIn from './components/GuestCheckIn'

export default {
  components: {
    TitleBar,
    SetUpDialog,
    SiteGuestQRCodeDialog,
    GuestCheckIn
  },
  data () {
    return {
      activeName: this.$route.name,
      openQRCode: false,
      openSiteQRCode: false,
      qrcodeEnable: {
        app: false,
        web: false
      },
      guestCauseList: [],
      canClickButton: true // 防止連點button參數
    }
  },
  computed: {
    tabName () {
      switch (this.activeName) {
      case 'PlusGuestReservation':
        return '已預約訪客列表'
      case 'GuestRecord':
        return '已抵達訪客列表'
      default:
        return ''
      }
    }
  },
  watch: {
    $route (to, from) {
      this.activeName = to.name
    }
  },
  async mounted () {
    await this.getComQRcodeEnable()
    await this.getGuestCauseList()
  },
  beforeDestroy () {
  },
  methods: {
    // 取得社區有無開啟QRCode
    getComQRcodeEnable () {
      return new Promise((resolve, reject) => {
        apiGuest.GuestRecordTabs.GetComQRcodeEnable().then((res) => {
          res.data.forEach(item => {
            if (item === 'App') { this.qrcodeEnable.app = true }
            if (item === 'Web') { this.qrcodeEnable.web = true }
          })
          resolve()
        }).catch((err) => {
          reject(err)
          console.log('錯誤訊息：', err.response)
        })
      })
    },
    // 取得訪客設定列表
    getGuestCauseList () {
      apiGuest.SetUpDialog.GetGuestCauseType().then((res) => {
        res.data.forEach(val => {
          val.edited = false
        })
        this.guestCauseList = res.data
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    checkTab (activeName, oldActiveName) {
      console.log(activeName, oldActiveName)
      // eslint-disable-next-line eqeqeq
      if (activeName == oldActiveName) { return false } else if (activeName === 'PlusGuestReservation') { this.$router.push({ name: activeName, params: { guestId: 'List' } }) } else if (activeName === 'GuestRecord') { this.$router.push({ name: activeName }) }
      this.openQRCode = false
      this.getGuestCauseList()
    },
    // 開啟設定彈窗
    openSetUpDialog () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.$refs.SetUpDialog.openDialog()
        setTimeout(() => {
          this.canClickButton = true
        }, 2000)
      }
    },
    // 開啟現場訪客登記表單彈窗
    openSiteGuestQRCodeDialog () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.$refs.SiteGuestQRCodeDialog.openDialog()
        setTimeout(() => {
          this.canClickButton = true
        }, 2000)
      }
    },
    // 開啟舊版訪客紀錄列表
    openOldVersionGuestRecord () {
      window.location.href = `${window.location.origin}/community/communityGuestRecord.aspx`
    }
  }
}
</script>
<style lang="sass" scoped>
#GuestRecordTabs_main
  +mainLayer
  .title_bar
    margin: 0 0 30px 0
    .title-link
      font-weight: normal
      margin-left: 9px
      text-decoration: underline
      font-size: 16px
      color: $mainColorDark
      cursor: pointer
  .checkin_block
    padding-bottom: 18px
  ::v-deep .el-tabs
    &.tabs
    +basicTabs
    .el-tabs__header
      margin: 0 0 0
    .el-tabs__active-bar
      height: 4px
    .el-tabs__nav-wrap::after
      height: 4px
    .el-tabs__item
      height: 46px
    #tab-PlusGuestReservation,#tab-GuestRecord
      min-width: 160px
  ::v-deep .el-dialog.QRCodePopup
    +basicDialog
    min-width: 500px
    img
      margin: 0px auto
      width: 260px
      display: block
    .el-divider
      margin: 16px 0
</style>
